export const scrollToTop = () => {
  const siteNav = document.querySelector("#site-header");
  if (siteNav) {
    window.scrollTo(0, siteNav.getBoundingClientRect().height);
  }
};

export const scrollToWithOffset = (selector: string, offset: number) => {
  const $element = $(selector);
  if ($element.length) {
    // @ts-ignore
    console.log($element.offset().top + offset);
    // @ts-ignore
    window.scrollTo(0, $element.offset().top + offset);
  }
};

export const getPriceFormatted = (price: number | undefined): string => {
  if (price === undefined) {
    return "";
  } else if (price === 0) {
    return "Included";
  } else {
    return "$" + price.toLocaleString();
  }
};
